import ReactSelect from 'react-select'
import React from 'react';
import Grid from '../../../molecules/Grid';
import TestingAnswerContent from '../TestingAnswerContent/TestingAnswerContent';
import TestingSelect from './styles.js';
import {SelectOptionsTypes} from '../TestingAnswersList/types';
import ErrorMessage from '../../../atoms/UI/forms/ErrorMessage/ErrorMessage';

type SelectTypes = {
    name: string;
    type: string;
    options?: SelectOptionsTypes[];
    value: string;
    label: string;
    placeholder: string | undefined;
    onChange: any;
    isComment?: boolean;
    commentText?: string;
    imgSrc?: string;
    isCorrect?: boolean;
    required?: boolean;
    error?: string;
    disabled: boolean;
    isClearable?: boolean;
};

export const TestingFormSelect: React.FC<SelectTypes> = ({
     name,
     options,
     value,
     label,
     placeholder,
     onChange,
     isComment,
     commentText,
     imgSrc,
     isCorrect,
     required,
     error,
     disabled,
     isClearable
}) => {

    const getValue = (value:any ) => {
        if (options) {
            return (value ? options.find((option) => option.value === value) : null)
        }
    }

    return (
        <Grid col='1' gap='2'>
            <TestingAnswerContent
                imgSrc={imgSrc}
                label={label}
                isComment={isComment}
                commentText={commentText}
                isCorrect={isCorrect}
                isSelected={value}
                isDisabled={disabled}
                required={required}
            />
            <TestingSelect>
                <ReactSelect
                    name={name}
                    placeholder={placeholder}
                    options={options}
                    value={getValue(value)}
                    onChange={onChange}
                    classNamePrefix={'Select'}
                    isDisabled={disabled}
                    isClearable={isClearable}
                    // menuIsOpen={true}
                />
            </TestingSelect>

            {error && <ErrorMessage>{error}</ErrorMessage>}

        </Grid>
    )
}


export default TestingFormSelect